import type React from 'react';

import { Link } from 'react-router';
import NoticeSiteHasBeenArchived from '../common/lib/NoticeSiteHasBeenArchived';
import type { MultiLang } from '../config';

import styles from './SiteIndex.module.css';

interface Props {
    lang: MultiLang;
}

const SiteIndex: React.FC<Props> = (props) => {
    const { lang } = props;
    return (
        <div className={styles.siteIndex}>
            <header></header>
            <div className={styles.title}>
                <span>Welcome to BRAIN ATLAS</span>
            </div>
            <div className={styles.notice}>
                <NoticeSiteHasBeenArchived lang={lang} />
            </div>
            <div className="clearfix">
                <div className={styles.image}></div>
                <div className={styles.links}>
                    <ul>
                        <li className={styles.degu}>
                            <Link to="/degu/modules/xoonips/listitem.php?index_id=24" title="Degu">
                                <span>Degu</span>
                            </Link>
                        </li>
                        <li className={styles.jm}>
                            <Link to="/jm/modules/xoonips/listitem.php?index_id=9" title="Japanese Macaque Monkey">
                                <span>Japanese Macaque Monkey</span>
                            </Link>
                        </li>
                        <li className={styles.marmoset}>
                            <Link to="/marmoset_html/" title="Common Marmoset">
                                <span>Common Marmoset</span>
                            </Link>
                        </li>
                    </ul>
                </div>
            </div>
            <footer>BSI-NI &amp; Laboratory for Symbolic Cognitive Development</footer>
        </div>
    );
};

export default SiteIndex;
